<template>
    <span>
      <!-- <keep-alive> -->
        <div class="custom-row ms-compare-container">
          <div class="col-xs-8 col-md-12 year-multiselect compare-multiselect">
            <multi-select v-model="selectedIndicator" :options="indicatorOptions.slice(0)"
              group-values="indicators" group-label="programArea" :group-select="false"
              :group-collapsible-expanded="false" @open="openedIndicatorMultiselect" @close="closedIndicatorMultiselect"
              :placeholder="indicatorMultiselectOpened?indicatorOpenedPlaceholder:indicatorPlaceholder"
              :allow-empty="false" :show-labels="true" track-by="name" label="name">
              <span slot="noResult">Oops! No elements found. Change the search query.</span>
            </multi-select>
          </div>
          <div class="col-xs-4 col-md-12 year-multiselect compare-multiselect">
            <multi-select v-model="selectedSource" :options="optionSources"
              :group-select="false" @open="openedSourceMultiselect" @close="closedSourceMultiselect"
              :hide-selected="false" :placeholder="sourceMultiselectOpened?sourceOpenedPlaceholder:sourcePlaceholder"
              :allow-empty="false" :show-labels="false">
              <span slot="noResult">Oops! No elements found. Change the search query.</span>
            </multi-select>
          </div>
          <!-- <div class="cr-3 year-multiselect compare-multiselect">
            <multi-select v-model="selectedYear" :options="optionYear" :hide-selected="false"
              :allow-empty="true" :show-labels="false">
            </multi-select>
          </div> -->
        </div>
        <div class="col-xs-12">
          <line-chart :sourceClicked="sourceSelected" :relativeIndicator="relativeIndicator" :selectedIndicator="selectedIndicator.name"
                      :selectedYear="selectedYear" :appData="appData" :selectedState="selectedState" :chartType="chartType" 
                      :indicatorClicked="indicatorClicked">
          </line-chart>
        </div>
        <b-modal :active.sync="expandedView" has-modal-card>
          <form action="">
              <div class="modal-card">
                  <header class="modal-card-head" style="padding: 0;">
                      <div class="custom-row ms-compare-container">
                        <div class="col-xs-8 year-multiselect compare-multiselect">
                          <multi-select v-model="selectedIndicator" :options="indicatorOptions.slice(0)"
                            group-values="indicators" group-label="programArea" :group-select="false"
                            :group-collapsible-expanded="false" @open="openedIndicatorMultiselect" @close="closedIndicatorMultiselect"
                            :hide-selected="false" :placeholder="indicatorMultiselectOpened?indicatorOpenedPlaceholder:indicatorPlaceholder"
                            :allow-empty="false" :show-labels="true" track-by="name" label="name">
                            <span slot="noResult">Oops! No elements found. Change the search query.</span>
                          </multi-select>
                        </div>
                        <div class="col-xs-4 year-multiselect compare-multiselect">
                          <multi-select v-model="selectedSource" :options="optionSources"
                            :group-select="false" @open="openedSourceMultiselect" @close="closedSourceMultiselect"
                            :hide-selected="false" :placeholder="sourceMultiselectOpened?sourceOpenedPlaceholder:sourcePlaceholder"
                            :show-labels="true">
                            <span slot="noResult">Oops! No elements found. Change the search query.</span>
                          </multi-select>
                        </div>
                        <!-- <div class="cr-3 year-multiselect compare-multiselect">
                          <multi-select v-model="selectedYear" :options="optionYear" :hide-selected="false"
                            :allow-empty="true" :show-labels="false">
                          </multi-select>
                        </div> -->
                      </div>
                      <p class="modal-card-title"></p>
                  </header>
                  <section>
                    <line-chart :sourceClicked="sourceSelected" :relativeIndicator="relativeIndicator" :selectedIndicator="selectedIndicator.name"
                                :selectedYear="selectedYear" :appData="appData" :selectedState="selectedState" :chartType="chartType"
                                :indicatorClicked="indicatorClicked">
                    </line-chart>
                  </section>
                  <footer class="modal-card-foot">
                      <button class="button is-danger pull-right" type="button" @click="closeExpandedBool">CLOSE</button>

                  </footer>
              </div>
          </form>
        </b-modal>
        <!-- <bar-chart v-show="chartType !== 'line'" :barChartData="chartData"></bar-chart> -->
      <!-- </keep-alive> -->
    </span>
</template>

<script>

import BarChart from './barChart'
import LineChart from './line'
// import MultiSelect from 'vue-multiselect'
// multiselect with dropdown/accordion
import MultiSelect from '@/assets/js-on/vue-multiselect';
import { log } from 'async';

export default {
  name: 'plotchartIndex',
  components:{
    BarChart, LineChart, MultiSelect
  },
  props: ['masterIndicator','relativeIndicator','indicatorOptions','appData','selectedState','chartType','isExpanded','indicatorClicked', 'sourceSelected'],
  data() {
    return {
      selectedIndicator: {name: ''},
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      dataSources : ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS",
"World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      optionStates: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa",
        "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo",
        "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi",  "Kwara", "Lagos", "Nasarawa",
        "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe",
        "Zamfara"
      ],
      optionSources: [],
      optionYear: [],
      selectedSource: 'MICS:2021',
      selectedYear: '',
      expandedView: false,
      collapsible: true,
      indicatorPlaceholder: '',
      indicatorOpenedPlaceholder: 'Search indicator',
      indicatorMultiselectOpened: false,
      sourcePlaceholder: '',
      sourceOpenedPlaceholder: 'Search sources',
      sourceMultiselectOpened: false
    }
  },
  methods: {
    // These methods handle the placeholder for all multiselects on the map component
    openedIndicatorMultiselect(){
      this.indicatorMultiselectOpened = true;
    },
    closedIndicatorMultiselect(){
      this.indicatorMultiselectOpened = false;
    },
    changedIndicator(e){
      this.indicatorMultiselectPlaceholder = e;
    },
    openedYearMultiselect(){
      this.yearMultiselectPlaceholder = 'Select year';
    },
    closedYearMultiselect(year){      
      this.yearMultiselectPlaceholder = year.toString();
    },
    openedSourceMultiselect() {
      this.sourceMultiselectOpened = true;
    },
    closedSourceMultiselect() {
      this.sourceMultiselectOpened = false;
    },
    // End of multiselect methods

    /**
     * This method emits a false value to compareSection.vue
     * This was done so as to make sure the expanded value of a section remains true
     * That way you're able to open a single section and close as much as you wish
     */
    closeExpandedBool(){
      this.expandedView = false;
      this.$emit('expanded',false);
    },
    /**
     * This method was previously used, but still remains here in case of further implementaions
     * Feel free to remove this method any time  
     */
    extractStateValuesForIndicator (indicator, selectedSource) {
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[indicator];
      var vt = ivt[1] === 'P'? '%': '';
      var it = ivt[1] === 'P'? '% of total': '';
      var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var selectedIndicatorValuesForEachState = {};
      var indicatorSource = indicator + ' -> ' + selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;

      var statesWithIndicatorsYearAndValues = this.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);

      if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
        for (var stateName in stateByIndicatorByYear) {
          if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
              // var len = stateByIndicatorByYear[stateName].length;
            var stateCurrentYearVals = stateByIndicatorByYear[stateName][statesWithIndicatorsYearAndValues[2][stateName]];
            selectedIndicatorValuesForEachState[stateName] = [stateCurrentYearVals[0], stateCurrentYearVals[indexOfindicatorSource]];
          }
        }
      }else{
        selectedIndicatorValuesForEachState = statesWithIndicatorsYearAndValues[0]
      }
      var temp = Object.keys(selectedIndicatorValuesForEachState);
      var obj = {};
      temp.map( (elem, index) => {
          obj[elem] = selectedIndicatorValuesForEachState[elem][1];
      });
      var regions = ['North-East', 'North-West', 'North-Central', 'South-East', 'South-West', 'South-South']
      var sortedObj = sortObjects(obj); // custom method
      var xAxis = [], yAxis = [];
      for (let stateName in sortedObj){
          if (sortedObj.hasOwnProperty(stateName)){
              if (regions.indexOf(stateName) < 0) { // don't need the regions in this chart
                  yAxis.push(stateName);
                  xAxis.push(sortedObj[stateName]);
              }
          }
      }
      var plotData = {}
      // get the data required for ngMap
      yAxis.map( (elem, index)=> {
          plotData[elem] = xAxis[index];
      });
      return plotData;
    },
    // This method is not currently used
    getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {

      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
          if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
              for ( var i = stateByIndicatorByYear[stateName].length - 1; i>=0; i--) {
                  statesWithIndicatorsYearAndValues[stateName] = [];
                  var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                  // if (selectedIndicatorVal) {
                  if (stateByIndicatorByYear[stateName][i][0] === parseInt(this.data[3])) {
                      tempArr[stateName] = i;
                      statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
                      break;
                  }
              }
              // get all the years where there's a value for the indicator...
              for ( var i = stateByIndicatorByYear[stateName].length - 1; i>=0; i--) {
                if(!sourceActiveYear[stateName]) {
                    sourceActiveYear[stateName] = {};
                }
                var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                if (selectedIndicatorVal) {
                  sourcetempArr.push(i)
                  sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                  // break;
                }
              }
          }
      }
      // we leverage the fact that National always has data for all the indicators
      // this.optionYear = Object.keys(sourceActiveYear['National']);
      var rowIndex = Math.max.apply(null, tempArr);
      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr]
    },
    /**
     * This method get the sources with available data for all states excluding National
     * This was done becuase National doesn't show up on the map
     */
    getCurrentSourceOptions(indicator) {
      let sources = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      for(var k in this.dataSources){
        for(var i in statesByIndicatorByYear){
          for(var j in statesByIndicatorByYear[i]){
            // if(i !== 'National'){
              let indicatorSource = indicator + ' -> ' + this.dataSources[k];
              let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource)-1;
              if(statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex>0){
                if(sources.indexOf(this.dataSources[k])<0)
                  sources.push(this.dataSources[k]);
                break;
              }
            // }
          }
        }
      }
      // this.optionSources = sources;
      return sources;
    },
     
    // This method get the years with available data for the selected indicator and source
    getYearOptionsWithData(indicator,source){
      let years = [];
      let statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      let indicatorSource = indicator + ' -> ' + source;
      let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource)-1;
      this.optionStates.map((elem,index) => {
        for (var i in statesByIndicatorByYear){
          statesByIndicatorByYear[elem].map((el,i) => {
            if(el[indicatorSourceIndex] !== "" && indicatorSourceIndex>0){
              if(years.indexOf(el[0]) < 0){
                years.push(el[0])
              }
            }
          });
        } 
      });
      this.optionYear = years.sort(function(a, b){return b-a})
    },
    multiselectSearch(){
      this.collapsible = false;
    },
    // This method assigns this.selectedSource and this.selectedYear
    // Was done to avoid repeated code writing
    yearComputation(indicator,source){
      this.getYearOptionsWithData(indicator,source);
      if(this.optionYear.length > 0){
        let randomYear = Math.floor(Math.random() * this.optionYear.length);
        let maxYear = Math.max.apply(null, this.optionYear);
        this.selectedYear = maxYear;
      } else {
        this.selectedYear = 0;
      }
       this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  },
  mounted () {
    //indicatorOptions','appData','relativeIndicator','mapType','isExpanded','indicatorClicked', 'sourceSelected'
    if (this.lsData) {
      // console.log(this.relativeIndicator);
      
      this.optionSources = this.getCurrentSourceOptions(this.relativeIndicator);
      this.indicatorPlaceholder = this.relativeIndicator;
      this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(this.relativeIndicator,this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
      // this.$store.dispatch('storeIndicatorSelected',this.relativeIndicator);
    }
  },
  computed: {
    
  },
  watch: {
    masterIndicator(val){
      this.$emit('indicatorClicked',val); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = this.selectedIndicator.name;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(name);
      if (this.optionSources.indexOf('MICS')< 0){
        this.selectedSource = this.optionSources[0];
      }
      else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(this.optionSources);
   
      this.yearComputation(name,this.selectedSource);
    },
    selectedIndicator({name}){
      this.$emit('indicatorClicked',name); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = name;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(name);
      if (this.optionSources.indexOf('MICS')< 0){
        this.selectedSource = this.optionSources[0];
      }
      else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(this.optionSources);
   
      this.yearComputation(name,this.selectedSource);
    },
    selectedSource(val){
      this.$emit('sourceSelected',val);

      this.sourcePlaceholder = val;
      if(this.selectedIndicator.name !== ''){
        this.yearComputation(this.selectedIndicator.name,val);
      } else {
        this.yearComputation(this.relativeIndicator,val);
      }
    },
    isExpanded(val){
      this.expandedView = val;
    },
    indicatorClicked(val) {      
      this.indicatorPlaceholder = val;
    },
    sourceSelected(val){
      // console.log(val); 
      this.selectedSource = val;
    },
    relativeIndicator(val){
       
      this.optionSources = this.getCurrentSourceOptions(val);
      // console.log(this.optionSources);
      
      this.indicatorPlaceholder = val;
      if (this.optionSources.indexOf('MICS')< 0){
        this.selectedSource = this.optionSources[0];
      }
      else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(val,this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?290ca3a4